import { j as h } from "../../../node_modules/react/jsx-runtime.js";
import { memo as F, useState as S, useRef as d, useEffect as r } from "react";
import { useFloating as p, FloatingFocusManager as P, FloatingPortal as tt } from "../../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { i18n as V } from "../../../utils/locale/locale.js";
import it from "../Button/Button.js";
import et from "../Calender/Calender.js";
import ft from "./useOnClickOutside.js";
import st from "../../../node_modules/lodash/isArray.js";
import { formatDate as s } from "../../../utils/helper.js";
import { DEFAULT_DATE_FORMAT as mt } from "../Calender/calender.helper.js";
import { offset as nt, flip as yt, shift as ut } from "../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { autoUpdate as at } from "../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import Dt from "./TextFieldMask/TextFieldMask.js";
import { isValid as wt } from "../../../node_modules/date-fns/isValid.js";
import { isAfter as ht } from "../../../node_modules/date-fns/isAfter.js";
import { isBefore as kt } from "../../../node_modules/date-fns/isBefore.js";
const gt = ({
  calenderProps: t = { type: "single" },
  buttonProps: K,
  textFieldProps: y,
  width: I,
  onChange: f,
  onRemoveDate: c,
  onClickOutside: Y,
  dateFormat: D = "yyyy-MM-dd",
  position: l = "bottom-start",
  triggerType: _ = "button",
  value: x,
  label: W
}) => {
  const [A, k] = S(
    (t == null ? void 0 : t.CalenderOpen) || !1
  ), [e, m] = S([]), [E, T] = S(null), $ = () => t != null && t.hasTimePicker ? "d MMM, yyyy hh:mm aa" : t != null && t.showMonthYearPicker ? "MMM yyyy" : mt, q = () => t != null && t.hasTimePicker ? "dd/MM/yyyy hh:mm aa" : t != null && t.showMonthYearPicker ? "MMM yyyy" : "dd/MM/yyyy", [G, B] = S($()), j = t == null ? void 0 : t.type, N = d(null), { refs: O, context: H, floatingStyles: J } = p({
    open: A,
    placement: l,
    middleware: [
      nt(l != null && l.includes("left") || l != null && l.includes("right") ? 10 : 5),
      yt({
        fallbackAxisSideDirection: "end"
      }),
      ut()
    ],
    whileElementsMounted: at
  });
  ft(N, () => {
    k(!1), Y && Y();
  });
  const Q = (i) => {
    const w = /^\d{2}\/\d{2}\/\d{4}$/, [M, u, g] = i.split("/").map(Number), n = new Date(g, u - 1, M), a = n.getFullYear() === g && n.getMonth() === u - 1 && n.getDate() === M;
    !w.test(i) || !a ? T("error_date_format") : (T(null), m([new Date(n)]), f == null || f(s(new Date(n), D), n));
  }, X = (i) => {
    const w = i.split(" - "), M = /^\d{2}\/\d{2}\/\d{4}$/, [u, g, n] = w[0].split("/").map(Number), a = new Date(n, g - 1, u), R = a.getFullYear() === n && a.getMonth() === g - 1 && a.getDate() === u, [z, L, U] = w[1].split("/").map(Number), b = new Date(U, L - 1, z), C = b.getFullYear() === U && b.getMonth() === L - 1 && b.getDate() === z;
    !M.test(w[0]) || !M.test(w[1]) || !R || !C ? T("error_date_format") : (T(null), m([new Date(a), new Date(b)]), f == null || f(
      [s(new Date(a), D), s(new Date(b), D)],
      [a, b]
    ));
  }, o = (i) => {
    m(i), T(null), t != null && t.footerActions || (f == null || f(
      j == "single" ? s(new Date(i[0]), D) : [
        s(new Date(i[0]), D),
        s(new Date(i[1]), D)
      ],
      j == "single" ? i[0] : i
    ), t != null && t.hasTimePicker || k(!1));
  }, v = (i) => (t == null ? void 0 : t.type) === "single" ? e[0] ? `${s(e[0], i)}` : "" : e.length > 1 ? `${s(e[0], i)} - ${s(
    e[e.length - 1],
    i
  )} ` : "", Z = {
    onClickApply: () => {
      var i;
      f == null || f(
        j == "single" ? s(new Date(e[0]), D) : [
          s(new Date(e[0]), D),
          s(new Date(e[1]), D)
        ],
        j == "single" ? e[0] : e
      ), k(!1), (i = t == null ? void 0 : t.footerActions) == null || i.onClickApply(e);
    },
    onCancel: () => {
      var i;
      m([]), k(!1), (i = t == null ? void 0 : t.footerActions) == null || i.onCancel();
    }
  };
  return r(() => {
    if (x) {
      const i = st(x) ? x : [x];
      t == null || t.type, m(i);
    } else
      m([]);
  }, [x]), /* @__PURE__ */ h.jsxs("div", { className: "flex flex-col gap-300", children: [
    /* @__PURE__ */ h.jsxs(
      "div",
      {
        className: "w-full",
        ref: O.setReference,
        children: [
          _ === "button" && /* @__PURE__ */ h.jsx(
            it,
            {
              style: { width: I || "100%" },
              variant: "outlined",
              color: "neutral",
              leadingIcon: "calendar",
              testId: "date-picker-button",
              ...K,
              label: v(`${$()}`) || V("select_date"),
              onClick: () => k(!0)
            }
          ),
          _ === "input" && /* @__PURE__ */ h.jsx(
            Dt,
            {
              ...y,
              isDatePickerOpen: A,
              width: I,
              label: W,
              type: t.type,
              onBlur: () => {
                B($());
              },
              onfocus: () => {
                k(!A), B(q());
              },
              value: typeof e == "string" ? e.toString() : v(G),
              hasTimePicker: t.hasTimePicker,
              helperText: (y == null ? void 0 : y.helperText) || V(E || "") || "",
              status: E ? "destructive" : y == null ? void 0 : y.status,
              testId: y == null ? void 0 : y.testId,
              onClickTrailingIcon: () => {
                m([]), c == null || c();
              },
              onKeyUp: (i) => {
                const [w, M, u] = i.currentTarget.value.split("/").map(Number), g = new Date(u, M - 1, w);
                if ((u == null ? void 0 : u.toString().length) > 3) {
                  const n = t.maxDate ? ht(g, new Date(t.maxDate)) : !1, a = t.maxDate ? kt(g, new Date(t.maxDate)) : !1;
                  (n || a) && (m([]), c == null || c());
                }
              },
              onKeyDown: (i) => {
                !/^[0-9]+$/.test(i.key) && i.key !== "Backspace" && i.preventDefault(), t.type === "range" && i.key === "Backspace" && m([]);
              },
              onChange: (i) => {
                m(i), t.type === "single" ? i.length === 10 && Q(i) : i.length === 23 && X(i);
              },
              onArrowClick: () => k(!A),
              onClickLeadingIcon: () => k(!A)
            }
          )
        ]
      }
    ),
    A && /* @__PURE__ */ h.jsx(
      P,
      {
        context: H,
        disabled: !0,
        children: /* @__PURE__ */ h.jsx(tt, { children: /* @__PURE__ */ h.jsx(
          "div",
          {
            ref: O.setFloating,
            style: { ...J, zIndex: 1006 },
            "data-testid": "dropdown",
            children: /* @__PURE__ */ h.jsx("div", { ref: N, children: /* @__PURE__ */ h.jsx(
              et,
              {
                showShadow: t.showShadow,
                testId: "date-picker-calendar",
                type: t.type,
                size: t.size,
                preSetRange: t.preSetRange,
                maxDate: t.maxDate,
                minDate: t.minDate,
                events: t.events,
                disabledDates: t.disabledDates,
                disableWeekends: t.disableWeekends,
                hasTimePicker: t.hasTimePicker,
                footerActions: t.footerActions && Z,
                showMonthYearPicker: t == null ? void 0 : t.showMonthYearPicker,
                value: (typeof e == "string" || e.length > 0) && !E ? j === "single" ? wt(new Date(e[0])) ? new Date(e[0]) : void 0 : e : void 0,
                onChange: (i) => {
                  t.type === "range" && Array.isArray(i) && i.length === 2 ? o(i) : t.type === "single" && o([i]);
                }
              }
            ) })
          }
        ) })
      }
    )
  ] });
}, Ot = F(gt);
export {
  Ot as default
};
//# sourceMappingURL=DatePicker.js.map
